module.exports = __webpack_public_path__ + "static/media/cherish.9da28090.png";